import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Header, Popup } from 'semantic-ui-react';
import _, { get, isEmpty } from 'lodash';
import client from '../../apollo';

import SaleInformationForm from './saleInformationForm';
import externalAuctionTransactionsEventDataQuery from '../../graphql/externalAuctionTransactionsEventDataQuery';
import ExportEAT from './ExportEAT';
import { parseString2Fields } from './StringUtil';

class ExternalAuctionTransactionsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      eatTransactionId: null,
      eatEvents: [],
      isEditModalOpen: false,
      editFormError: null,
      query: false,
      vinHeader: null,
    };
  }

  onClickSaleInformation = (id, vin) => () => {
    this.setState({
      eatTransactionId: id,
      vinHeader: vin,
      eatEvents: [],
      isEditModalOpen: true,
      query: true,
      loading: true,
    });
    this.handleData(id);
  };

  handleData = id => {
    client
      .query({
        query: externalAuctionTransactionsEventDataQuery,
        variables: {
          eatTransactionId: parseInt(id, 10),
        },
      })
      .then(({ data }) => {
        const result = get(data, 'externalAuctionTransactionsEventData');
        if (!isEmpty(result)) {
          this.setState({
            eatEvents: result,
            query: false,
            loading: false,
          });
        } else {
          this.setState({
            query: false,
            loading: false,
          });
        }
      });
  };

  onEditFormCloseHandler = () => {
    this.setState({
      editFormError: null,
      isEditModalOpen: false,
      query: false,
    });
  };

  render() {
    const { eatEvents } = this.state;
    const eatEventsMap = [...eatEvents];
    const eatEventData = [...new Set(eatEventsMap)];
    const {
      externalAuctionTransactionsData,
      handleSort,
      column,
      direction,
      vin,
      dealerNumber,
      auction,
      purchaseLocation,
      saleDate,
    } = this.props;
    const {
      editFormError,
      isEditModalOpen,
      query,
      eatTransactionId,
      vinHeader,
      loading,
    } = this.state;

    const headerRow = (
      <Table.Row>
        <Table.HeaderCell>VIN</Table.HeaderCell>
        <Table.HeaderCell>Vehicle</Table.HeaderCell>
        <Table.HeaderCell
          sorted={column === 'purchaseLocation' ? direction : null}
          onClick={handleSort('purchaseLocation')}
        >
          Auction Location
        </Table.HeaderCell>
        <Table.HeaderCell>Sale Date</Table.HeaderCell>
        <Table.HeaderCell
          sorted={column === 'buyer' ? direction : null}
          onClick={handleSort('buyer')}
        >
          Buyer Name
        </Table.HeaderCell>
        <Table.HeaderCell
          sorted={column === 'seller' ? direction : null}
          onClick={handleSort('seller')}
        >
          Seller Name
        </Table.HeaderCell>
      </Table.Row>
    );
    const rowBody = [];
    if (!isEmpty(externalAuctionTransactionsData)) {
      externalAuctionTransactionsData.forEach(value => {
        const {
          id,
          vin: vinValue,
          buyer,
          buyerName,
          seller,
          sellerName,
          saleDate: saleDateValue,
          modelYear,
          make,
          model,
          auction: auctionValue,
          purchaseLocation: purchaseLocationValue,
        } = value;

        const vehicle = `${_.toString(modelYear)} ${_.toString(
          make
        )} ${_.toString(model)}`;

        rowBody.push(
          <Popup
            key={id}
            trigger={(
              <Table.Row
                key={id}
                onClick={this.onClickSaleInformation(id, vinValue)}
              >
                <Table.Cell>{vinValue}</Table.Cell>
                <Table.Cell>{vehicle}</Table.Cell>
                <Table.Cell>
                  {parseString2Fields(purchaseLocationValue, auctionValue)}{' '}
                </Table.Cell>
                <Table.Cell>{saleDateValue}</Table.Cell>
                <Table.Cell>{parseString2Fields(buyer, buyerName)}</Table.Cell>
                <Table.Cell>
                  {parseString2Fields(seller, sellerName)}
                </Table.Cell>
              </Table.Row>
            )}
            content='Click to view Sales Transaction details'
            position='top center'
            wide={30}
          />
        );
      });
    } else {
      rowBody.push(
        <Table.Row key='No-Record' colSpan={6}>
          <Table.Cell colSpan={6} textAlign='center'>
            <div> No Records Found</div>
          </Table.Cell>
        </Table.Row>
      );
    }
    return (
      <div>
        {!isEmpty(externalAuctionTransactionsData) ? (
          <ExportEAT
            vin={vin}
            dealerNumber={dealerNumber}
            auction={auction}
            purchaseLocation={purchaseLocation}
            saleDate={saleDate}
          />
        ) : null}
        <br />
        <Header>Sales Transactions</Header>
        <div style={{ overflowX: 'auto', whiteSpace: 'no-wrap' }}>
          <Table celled selectable padded sortable size='small' striped>
            <Table.Header>{headerRow}</Table.Header>
            <Table.Body>{rowBody}</Table.Body>
          </Table>
        </div>
        <br />
        <br />
        {isEditModalOpen && (
          <div>
            <SaleInformationForm
              isModalOpen={isEditModalOpen}
              onCloseHandler={this.onEditFormCloseHandler}
              error={editFormError}
              query={query}
              eatTransactionId={eatTransactionId}
              externalAuctionTransactionsEventData={eatEventData}
              vinHeader={vinHeader}
              loading={loading}
            />
          </div>
        )}
      </div>
    );
  }
}

ExternalAuctionTransactionsList.propTypes = {
  externalAuctionTransactionsData: PropTypes.arrayOf(PropTypes.object),
  handleSort: PropTypes.func,
  column: PropTypes.string,
  direction: PropTypes.string,
  vin: PropTypes.string,
  dealerNumber: PropTypes.string,
  auction: PropTypes.string,
  purchaseLocation: PropTypes.string,
  saleDate: PropTypes.string,
};

ExternalAuctionTransactionsList.defaultProps = {
  externalAuctionTransactionsData: [],
  handleSort: () => {},
  column: null,
  direction: null,
  vin: '',
  dealerNumber: '',
  auction: '',
  purchaseLocation: '',
  saleDate: '',
};

export default ExternalAuctionTransactionsList;
